import { memo } from 'react'
import { Text, DotsLoading } from 'common-components'
import ImageStyleItem from './Item'
import NotAllowedIcon from 'assets/svgr-icons/Not_Allowed.svg'
import { NOT_SELECTED_STYLE, NOT_SELECTED_STYLE_ID } from '../consts'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { COLORS } from 'consts/colors'
import { IAiImageStylesState } from 'store/types/aiImage'

interface IProps {
  styles: IAiImageStylesState
  handleStyleClick: (id: string | number) => void
  currentStyleId: string | number
}

const ImageStylesContent: React.FC<IProps> = ({
  styles,
  handleStyleClick,
  currentStyleId
}) => {
  const isLoading = useSelector(aiImageSelectors.isStylesLoading)

  return (
    <Styled.ImageStylesContainer>
      <Text type="h1" color="secondaryDark">
        {translate(T.SELECT_LABEL)}
      </Text>
      {isLoading ? (
        <DotsLoading dotColor={COLORS.primaryDark} size="xSmall" />
      ) : (
        <Styled.ImageStylesOverflow>
          <Styled.ImageStylesContentWrapper>
            <Styled.NotSelectedStyleItem
              $isSelected={currentStyleId === NOT_SELECTED_STYLE_ID}
              $isDefaultStyle={true}
              onClick={() => handleStyleClick(NOT_SELECTED_STYLE.id)}
            >
              <NotAllowedIcon />
            </Styled.NotSelectedStyleItem>
            {styles.data?.map(item => {
              const { id } = item
              const isSelected = currentStyleId === id
              return (
                <ImageStyleItem
                  key={id}
                  item={item}
                  isSelected={isSelected}
                  onStyleClick={handleStyleClick}
                />
              )
            })}
          </Styled.ImageStylesContentWrapper>
        </Styled.ImageStylesOverflow>
      )}
    </Styled.ImageStylesContainer>
  )
}

export default memo(ImageStylesContent)
